import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../Components/Loading';
import BackButton from '../../Components/BackButton';
const parse = require('html-react-parser');

const ArticlePage = () => {
   const { articleId } = useParams();
   const [article, setArticle] = useState<any>();

   useEffect(() => {
      axios
         .get(`${process.env.REACT_APP_API}/article/${articleId}`)
         .then(result => result.data && setArticle(result.data))
         .catch(error => console.log('Unable to retrieve article', error));
   }, [articleId]);

   if (!article) return <Loading label="Loading article" />;

   return (
      <div className="container-sm pt-28">
         <BackButton />
         <article className="prose-dark mt-8">
            <p className="eyebrow mb-4 text-signal-soft">Article</p>
            <h1 className="mb-10 font-display text-5xl leading-[1] text-bone md:text-6xl">{article.title}</h1>
            {article.cover && <img src={article.cover} alt="" className="mb-10 w-full rounded-sm" />}
            <div>{parse(article.content || '')}</div>
         </article>
      </div>
   );
};

export default ArticlePage;
